export default "__VITE_ASSET__1c76652d__"